import React from 'react';
import styles from './CardBadge.module.scss';

export const BADGE_TYPES = {
    INFO: 'info',
    ERROR: 'error',
    WARN: 'warn',
    DISABLED: 'disabled',
    SUCCESS: 'success',
};

const badgeStyleMap = {
    [BADGE_TYPES.INFO]: styles.badgeInfo,
    [BADGE_TYPES.ERROR]: styles.badgeError,
    [BADGE_TYPES.WARN]: styles.badgeWarn,
    [BADGE_TYPES.DISABLED]: styles.badgeDisabled,
    [BADGE_TYPES.SUCCESS]: styles.badgeSuccess,
};

const Badge = ({ type = BADGE_TYPES.INFO, children, className = '' }) => {
    if (!type) return null;

    return (
        <span
            className={`${styles.badge} ${badgeStyleMap[type]} ${className}`}
            role="status"
        >
            {children}
        </span>
    );
};

export default Badge;